<template>
  <CCard class="shadow-sm rounded-3 bg-white">
    <CCardHeader style="background-color: #145654" 
      class="border-bottom d-flex flex-column flex-md-row justify-content-between align-items-center py-3">
        <h4 class="card-title mb-2 mb-md-0 text-white d-flex align-items-center">
          <CIcon name="cil-people" size="xl" class="mr-2"/> 
          <span>{{ $t('staffMgmt.pageTitle') }}</span>
        </h4>
        <div class="d-flex align-items-center gap-2 btn-add-mobile">
          <CButton v-if="selectedUsers.length > 0" color="danger" shape="pill" @click="deleteMultipleUsers()">
            <CIcon name="cil-trash" /> {{ $t('staffMgmt.deleteSelected') }} ({{ selectedUsers.length }})
          </CButton>
          <CButton color="success" shape="pill" @click="openAddModal()">
            <CIcon name="cil-user-follow" />&nbsp;{{ $t('staffMgmt.addStaff') }}
          </CButton>
        </div>
    </CCardHeader>

    <CCardBody class="p-2 p-md-4">
      <div v-if="currentDepartmentName">
        <h4 class="d-flex mb-3 justify-content-between align-items-center dept-title">
          {{ divisionHeading }} {{ currentDepartmentName }}
        </h4>
        
        <CDataTable 
          class="custom-pagination" 
          :items="tableUsers" 
          :fields="tableFields" 
          hover striped sorter
          :pagination="{ doubleArrows: false, align: 'center' }"
          :items-per-page="perPage" 
          :active-page="activePage"
          @page-change="activePage = $event"
          @pagination-change="perPage = $event"
          @filtered-items-change="onFilteredItemsChange"
          table-filter 
          items-per-page-select
          responsive
        >
          <template #select-header>
            <input type="checkbox" @change="toggleSelectAll($event.target.checked)" :checked="isPageSelected" style="cursor: pointer; width: 1.2em; height: 1.2em;" />
          </template>

          <template #select="{ item }">
            <td class="text-center align-middle">
              <input type="checkbox" :value="item._id" v-model="selectedUsers" style="cursor: pointer; width: 1.2em; height: 1.2em;" />
            </td>
          </template>

          <template #name="{ item }">
            <td><div class="table-text">{{ item.name }}</div></td>
          </template>

          <template #surname="{ item }">
            <td><div class="table-text">{{ item.surname }}</div></td>
          </template>

          <template #email="{ item }">
             <td><div class="table-text text-truncate" style="max-width: 150px;">{{ item.email }}</div></td>
          </template>

          <template #mobile_phone="{ item }">
            <td><div class="table-text">{{ item.mobile_phone }}</div></td>
          </template>

          <template #role="{ item }">
            <td>
              <div class="table-text">{{ item.role }}</div>
            </td>
          </template>

          <template #actions="{ item }">
            <td class="text-center">
              <div class="d-flex justify-content-center gap-2">
                <CButton size="sm" color="warning" shape="pill" @click="openEditModal(item)">
                    <CIcon name="cil-pencil" />
                </CButton>
                <CButton size="sm" color="danger" shape="pill" @click="deleteUser(item)">
                    <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </CDataTable>
      </div>
      <div v-else class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <div class="mt-2">{{ $t('mgmt.loadingDept') }}</div>
      </div>
    </CCardBody>

    <CModal :title="$t('staffMgmt.addModal')" :show.sync="showaddModal" size="lg" color="warning" centered>
      <CModalBody v-if="addUser" class="p-2">
        <CForm>
          <div class="p-2">
            <CRow>
              <CCol sm="6"><CInput :label="$t('staffMgmt.firstName')" v-model="addUser.name" /></CCol>
              <CCol sm="6"><CInput :label="$t('staffMgmt.lastName')" v-model="addUser.surname" /></CCol>
            </CRow>
            <CRow>
              <CCol sm="6"><CInput :label="$t('staffMgmt.email')" v-model="addUser.email" /></CCol>
              <CCol sm="6"><CInput :label="$t('staffMgmt.phone')" v-model="addUser.mobile_phone" /></CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CSelect :label="$t('staffMgmt.userType')" :options="roleOptions" :value="addUser.role" @change="onChangeAddRole" />
              </CCol>
              <CCol sm="6">
                <CInput :label="divisionLabel" :value="currentDepartmentName" disabled />
              </CCol>
            </CRow>
          </div>
        </CForm>
      </CModalBody>
      <template #footer>
        <CButton shape="pill" color="danger" @click="showaddModal = false">{{ $t('mgmt.cancel') }}</CButton>
        <CButton shape="pill" color="success" @click="saveaddUser">{{ $t('mgmt.add') }}</CButton>
      </template>
    </CModal>

    <CModal :title="$t('staffMgmt.editModal')" :show.sync="showeditModal" size="lg" color="warning" centered>
      <CModalBody v-if="editUser" class="p-2">
        <CForm>
           <div class="p-2">
             <CRow>
               <CCol sm="6"><CInput :label="$t('staffMgmt.firstName')" v-model="editUser.name" /></CCol>
               <CCol sm="6"><CInput :label="$t('staffMgmt.lastName')" v-model="editUser.surname" /></CCol>
             </CRow>
             <CRow>
               <CCol sm="6"><CInput :label="$t('staffMgmt.email')" v-model="editUser.email" disabled /></CCol>
               <CCol sm="6"><CInput :label="$t('staffMgmt.phone')" v-model="editUser.mobile_phone" /></CCol>
             </CRow>
             <CRow>
              <CCol sm="6">
                <CSelect :label="$t('staffMgmt.userType')" :options="roleOptions" :value="editUser.role" @change="(e) => (editUser.role = e.target.value)" />
              </CCol>
              <CCol sm="6">
                 <CInput :label="divisionLabel" :value="currentDepartmentName" disabled />
              </CCol>
             </CRow>
           </div>
        </CForm>
      </CModalBody>
      <template #footer>
        <CButton shape="pill" color="danger" @click="showeditModal = false">{{ $t('mgmt.cancel') }}</CButton>
        <CButton shape="pill" color="success" @click="saveUser">{{ $t('mgmt.save') }}</CButton>
      </template>
    </CModal>
  </CCard>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      selectedUsers: [],
      tableUsers: [], 
      currentDepartmentName: "", 

      showaddModal: false,
      showeditModal: false,
      addUser: null,
      editUser: null,
      roleOptions: [
        { value: "supervisor", label: "Supervisor" },
        { value: "technician", label: "Technician" },
      ],
      activePage: 1,
      perPage: 5,
      filteredUsers: [],
    };
  },

  computed: {
    divisionLabel() {
      return this.$store.state.locale.lang === "th"
        ? "ฝ่าย (ประเภทงานซ่อม)"
        : "Division (repair category)";
    },
    divisionHeading() {
      return `${this.divisionLabel}:`;
    },
    tableFields() {
      return [
        { key: "select", label: "", _style: "width: 1%; text-align: center;", sorter: false, filter: false },
        { key: "name", label: this.$t("staffMgmt.firstName"), _style: "min-width: 120px;" },
        { key: "surname", label: this.$t("staffMgmt.lastName"), _style: "min-width: 120px;" },
        { key: "email", label: this.$t("staffMgmt.email"), _style: "min-width: 180px;" },
        { key: "mobile_phone", label: this.$t("staffMgmt.phone"), _style: "min-width: 120px;" },
        { key: "role", label: this.$t("staffMgmt.userType"), _style: "min-width: 100px;" },
        { key: "deptNameDisplay", label: this.divisionLabel, _style: "min-width: 140px;" },
        { key: "actions", label: this.$t("mgmt.actions"), _style: "min-width: 120px; text-align:center;" },
      ];
    },
    currentPageUsers() {
      const start = (this.activePage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredUsers.slice(start, end);
    },
    isPageSelected() {
      if (this.currentPageUsers.length === 0) return false;
      return this.currentPageUsers.every(u => this.selectedUsers.includes(u._id));
    },
  },

  mounted() {
    this.fetchMyDepartmentUsers();
  },

  methods: {
    async fetchMyDepartmentUsers() {
      try {
        const token = localStorage.getItem("accessToken");
        const res = await axios.get(`${process.env.VUE_APP_APP_URL}/user/supervisor_user`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const users = res.data.data;
        
        if (users.length > 0 && users[0].department) {
           this.currentDepartmentName = users[0].department.departmentName;
        } else {
           this.currentDepartmentName = this.$t("staffMgmt.yourDept"); 
        }

        this.tableUsers = users.map(user => ({
          ...user,
          department: user.department?._id || user.department || "",
          deptNameDisplay: user.department?.departmentName || this.currentDepartmentName,
          mobile_phone: user.mobile_phone || "",
        }));
        this.filteredUsers = JSON.parse(JSON.stringify(this.tableUsers));

      } catch (err) {
        console.error("Error loading users:", err);
      }
    },

    openAddModal() {
      this.addUser = {
        name: "",
        surname: "",
        email: "",
        mobile_phone: "",
        role: "technician",
      };
      this.showaddModal = true;
    },

    onChangeAddRole(e) {
      this.addUser.role = e.target.value;
    },

    async saveaddUser() {
      if (!this.addUser.name || !this.addUser.surname || !this.addUser.email || !this.addUser.mobile_phone ||!this.addUser.role) {
        Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.errFillAllShort"), "error");
        return;
      }
      try {
        const token = localStorage.getItem("accessToken");
        const res = await axios.post(`${process.env.VUE_APP_APP_URL}/user/supervisor_user`, this.addUser, {
            headers: { Authorization: `Bearer ${token}` }
        });

        if (res.data?.success === false) {
          Swal.fire(this.$t("mgmt.error"), res.data.message, "error");
          return;
        }
        Swal.fire(this.$t("mgmt.success"), this.$t("mgmt.addSaved"), "success");
        this.showaddModal = false;
        this.fetchMyDepartmentUsers();
      } catch (err) {
        Swal.fire(this.$t("mgmt.error"), err.response?.data?.message || this.$t("mgmt.addFail"), "error");
      }
    },

    openEditModal(item) {
      this.editUser = JSON.parse(JSON.stringify(item));
      this.showeditModal = true;
    },

    async saveUser() {
            if (
        !this.editUser.name ||
        !this.editUser.surname ||
        !this.editUser.email ||
        !this.editUser.mobile_phone ||
        !this.editUser.role ||
        !this.editUser.department
      ) {
        Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.errFillAll"), "error");
        return;
      }
      try {
        const token = localStorage.getItem("accessToken");
        await axios.put(`${process.env.VUE_APP_APP_URL}/user/supervisor_user`, this.editUser, {
             headers: { Authorization: `Bearer ${token}` }
        });

        Swal.fire(this.$t("mgmt.success"), this.$t("mgmt.editSaved"), "success");
        this.showeditModal = false;
        this.fetchMyDepartmentUsers();
      } catch (err) {
        Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.editFail"), "error");
      }
    },

    async deleteUser(item) {
      const confirm = await Swal.fire({
        title: this.$t("mgmt.deleteUserTitle"),
        text: `${item.name} ${item.surname}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirm"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });

      if (!confirm.isConfirmed) return;

      const confirm2 = await Swal.fire({
        title: this.$t("mgmt.sureDelete"),
        text: `${item.name} ${item.surname} — ${this.$t("mgmt.demoteUserSuffix")}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirmDelete"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });

      if (!confirm2.isConfirmed) return;

      try {
        const res = await axios.put(`${process.env.VUE_APP_APP_URL}/user/del_user`, item);

        if (res.data) {
          Swal.fire(this.$t("mgmt.success"), this.$t("mgmt.demoteSuccess"), "success");
          this.selectedUsers = this.selectedUsers.filter(id => id !== item._id);
          this.fetchMyDepartmentUsers();
        }
      } catch (err) {
        Swal.fire(this.$t("mgmt.error"), err.response?.data?.message || this.$t("mgmt.errOperation"), "error");
      }
    },

    onFilteredItemsChange(items) {
      this.filteredUsers = items;
    },

    toggleSelectAll(checked) {
      const pageIds = this.currentPageUsers.map(u => u._id);
      if (checked) {
        const newSelected = [...this.selectedUsers];
        pageIds.forEach(id => {
          if (!newSelected.includes(id)) {
            newSelected.push(id);
          }
        });
        this.selectedUsers = newSelected;
      } else {
        this.selectedUsers = this.selectedUsers.filter(id => !pageIds.includes(id));
      }
    },

    async deleteMultipleUsers() {
      const confirm = await Swal.fire({
        title: this.$t("mgmt.deleteUserBulkTitle"),
        text: `${this.$t("mgmt.countItems")} ${this.selectedUsers.length} ${this.$t("mgmt.itemsUnit")}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirm"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });
      if (!confirm.isConfirmed) return;

      const confirm2 = await Swal.fire({
        title: this.$t("mgmt.sureDelete"),
        text: this.$t("mgmt.demoteUsersBulk"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirmDelete"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });
      if (!confirm2.isConfirmed) return;

      Swal.fire({
        title: this.$t("mgmt.loadingDelete"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      let successCount = 0;
      let failCount = 0;

      for (const userId of this.selectedUsers) {
        try {
          const res = await axios.put(`${process.env.VUE_APP_APP_URL}/user/del_user`, { _id: userId });
          if (res.data) successCount++;
        } catch (err) {
          failCount++;
        }
      }

      Swal.fire({
        title: failCount === 0 ? this.$t("mgmt.success") : this.$t("mgmt.doneTitle"),
        html: `${this.$t("mgmt.batchDeleted")} ${successCount} ${this.$t("mgmt.itemsUnit")}` + (failCount > 0 ? `<br>${this.$t("mgmt.batchFailed")} ${failCount} ${this.$t("mgmt.itemsUnit")}` : ""),
        icon: failCount === 0 ? "success" : "warning"
      });
      
      this.selectedUsers = [];
      this.fetchMyDepartmentUsers();
    },
  },
};
</script>

<style scoped>
.custom-pagination .page-item.active .page-link {
  background-color: #2ba9a5 !important;
  border-color: #2ba9a5 !important;
  color: #ffffff;
}

.custom-pagination .page-item .page-link {
  color: #414141;
}

.custom-pagination .page-item:not(.active) .page-link:hover {
  background-color: #f0f0f0;
}

.modal-header {
  background-color: #2a8577 !important;
}

/* เพิ่ม CSS สำหรับเว้นระยะห่างปุ่ม */
.gap-2 {
  gap: 0.5rem; /* เว้นระยะ 8px */
}

/* =========================================
   📱 Mobile Responsive Styles (< 768px)
   ========================================= */
@media (max-width: 768px) {
  .btn-add-mobile {
    width: 100%;
    margin-top: 10px;
  }
  
  .dept-title {
    font-size: 1.1rem;
    text-align: center;
    display: block !important;
  }
  
  .table-text {
    font-size: 0.9rem;
    white-space: nowrap;
  }
}
</style>